// export { default as Other } from './other';
import { useFlags } from 'launchdarkly-react-client-sdk';

import OtherForm from './other';
import OtherFormNew, { Props } from './otherNew';

export const Other = ({ closeModal, clientId }: Props) => {
  const { enableDateTimeUpdates } = useFlags();

  return enableDateTimeUpdates ? (
    <OtherFormNew closeModal={closeModal} clientId={clientId} />
  ) : (
    <OtherForm closeModal={closeModal} clientId={clientId} />
  );
};
